import { SurveyLanguage } from "../models/survey"

export const surveyLanguages: SurveyLanguage[] = [
    { name: "English", code: "en", direction: "ltr" },
    { name: "Arabic", code: "ar", direction: "rtl" },
    { name: "German", code: "de", direction: "ltr" },
    { name: "French", code: "fr", direction: "ltr" },
    { name: "Farsi/Dari", code: "fay", direction: "rtl" },
    { name: "Kurmanji", code: "kurk", direction: "ltr" },
    { name: "Russian", code: "ru", direction: "ltr" },
    { name: "Tamil", code: "ta", direction: "ltr" },
    { name: "Tigrinya", code: "ti", direction: "ltr" },
    { name: "Turkish", code: "tr", direction: "ltr" },
    { name: "Ukranian", code: "uk", direction: "ltr" },
    { name: "Pashto", code: "ps", direction: "rtl" },
]

export function getTranslatedMessage(
    key: string,
    variables: Record<string, any> = {},
    langCode: string = "en"
): string {
    const { unansweredCount } = variables;

    switch (key) {
        case "DIALOG_MSG_SURVEY":
            return getDialogMsgSurvey(langCode, unansweredCount);
        default:
            return "";
    }
}

export function getDialogMsgSurvey(langCode: string, count: number = 0): string {
    switch (langCode) {
        case "en":
            return `You have ${count} unanswered questions. After you submit, you can't edit this survey. Do you want to submit anyway?`;
        case "ar":
            return `لديك ${count} من الأسئلة غير المجابة. بعد الإرسال، لا يمكنك تعديل هذا الاستبيان. هل تريد الإرسال؟`;
        case "de":
            return `Sie haben ${count} unbeantwortete Fragen. Nach dem Absenden können Sie diese Umfrage nicht mehr bearbeiten. Möchten Sie trotzdem absenden?`;
        case "fr":
            return `Il vous reste ${count} questions sans réponse. Une fois que vous avez soumis, vous ne pouvez plus modifier ce sondage. Voulez-vous quand même soumettre ?`;
        case "fay": // Farsi/Dari
            return `شما ${count} سوال بدون پاسخ دارید. پس از ارسال، نمی‌توانید این نظرسنجی را ویرایش کنید. آیا می‌خواهید ارسال کنید؟`;
        case "kurk": // Kurmanji
            return `Te ${count} pirsên bê bersiv hene. Piştî şandinê nikarî vê lêpirsînê biguherînî. Tu dixwazî bi her re şandinekî bikî?`;
        case "ru":
            return `У вас ${count} незаполненных вопросов. После отправки вы не сможете изменить этот опрос. Хотите отправить?`;
        case "ta": // Tamil
            return `உங்களுக்கு ${count} பதிலளிக்கப்படாத கேள்விகள் உள்ளன. நீங்கள் சமர்ப்பித்த பிறகு, இந்த கருத்துக்கணிப்பைத் தொகுக்க முடியாது. நீங்கள் சமர்ப்பிக்க விரும்புகிறீர்களா?`;
        case "ti": // Tigrinya
            return `ኣብነቱ ኣልቦ ${count} ሕቶታት ዘይመልስኩም ኣሎኩም። ኣብ ኋላ ናብቲ ምርመራ ክትገልጹን ኣይኽእሉን። ብደሓን ትሰምርምሩ?`;
        case "tr":
            return `${count} yanıtlanmamış sorunuz var. Gönderdikten sonra bu anketi düzenleyemezsiniz. Yine de göndermek istiyor musunuz?`;
        case "uk":
            return `У вас ${count} незаповнених питань. Після надсилання ви не зможете змінити це опитування. Бажаєте надіслати?`;
        case "ps":
            return `تاسو ${count} نه ځواب شوي پوښتنې لرئ. د سپارلو وروسته، تاسو نشئ کولی دا سروې سم کړئ. ایا غواړئ چې وسپارئ؟`;
        default:
            return `You have ${count} unanswered questions. After you submit, you can't edit this survey. Do you want to submit anyway?`;
    }
}
